import Swiper from "swiper/bundle";
import faq from "../modules/faq";
import helpers from "../utils/helpers";
import Youtube from "../modules/youtube";
import LazyLoad from "vanilla-lazyload";

const SingleProduct = {
  init: function () {
    SingleProduct.newGift();
    SingleProduct.related();
    SingleProduct.crossoverProducts();
    SingleProduct.loadComments();
    SingleProduct.technicalDataCollapsing();
    SingleProduct.productNav();
    SingleProduct.reviewPopup();
    faq.init();
    SingleProduct.productAccordions();
    SingleProduct.deliveryProgressIndicator();
    SingleProduct.events();
    Youtube.init();
    SingleProduct.crossSaleSlider();
    SingleProduct.playShortSmallVideo();
    SingleProduct.showWarrantyVideoPopup();

    const receiveOfferForm = $("#receive-offer");
    if (receiveOfferForm.length) {
      SingleProduct.form();
      SingleProduct.receiveOrderPopup();
    }
  },

  events() {

    $('.yt-video--mp4 .yt-video__close').on('click', function () {
      const videoWrapEl = $(this).closest('.yt-video--mp4');
      videoWrapEl.removeClass('playing');
      videoWrapEl.find('video')[0].pause();
    });
    $(document).keyup(function (e) {
      if (e.key === "Escape" && $('.yt-video--mp4').hasClass("playing")) {
        $('.yt-video--mp4').removeClass('playing');
        $('.yt-video--mp4').find('video')[0].pause();
      }
    });

  },

  playShortSmallVideo() {
    // Video
    const videoWrapEl = $('.short-video-small');



    if (videoWrapEl.length > 0) {

      videoWrapEl.addClass('ready');

      new LazyLoad.load(
        videoWrapEl.find('video')[0],
        {
          callback_loaded: function (el) {
            videoWrapEl.addClass('playing');
            el.play();
          }
        }
      );
    }
  },

  showWarrantyVideoPopup() {
    const popupWrap = document.querySelector(".warranty-video-popup-wrap");
    if (!popupWrap) {
      return;
    }

    // Video opener only (PDF/document button shares .warranty__btn but must not toggle the popup)
    const showBtns = document.querySelectorAll(".warranty__btn");
    if (!showBtns.length) {
      return;
    }

    showBtns.forEach((showBtn) => {
      // Skip the terms PDF control (contains an <a>), keep the video trigger
      if (showBtn.querySelector("a[href]")) {
        return;
      }
      showBtn.addEventListener("click", function (e) {
        e.preventDefault();
        popupWrap.classList.toggle("hidden");
      });
    });
  },

  newGift() {
    $(".toggle-new-prod-gift").on("click", (e) => {
      e.preventDefault();
      const btnEl = $(e.currentTarget);

      btnEl.toggleClass("open");
      btnEl.siblings(".new-prod-gift__content").slideToggle();
    });
  },

  related: function () {
    var relatedEl = $(".related-products");
    if (relatedEl.length) {
      var relatedSlider = new Swiper(
        relatedEl.find(".related-products-slider"),
        {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          breakpoints: {
            480: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
              navigation: {
                prevEl: relatedEl.find(".swiper-prev"),
                nextEl: relatedEl.find(".swiper-next"),
              },
            },
            1200: {
              slidesPerView: 4,
            },
          },
        }
      );
    }
  },

  crossoverProducts: function () {
    let crossSaleCtr = $(".cross-sale-products");
    if (crossSaleCtr.length > 0) {
      let checkboxes = $(".sale-product__checkbox");
      let allRows = $(".cross-sale-products__row");

      allRows.each(function () {
        SingleProduct.updateCrossSaleRow($(this));
      });

      checkboxes.click(function () {
        let parent = $(this).parents(".cross-sale-products__row");
        $(this).parents(".sale-product").toggleClass("checked");
        SingleProduct.updateCrossSaleRow(parent);
      });

      crossSaleCtr.on(
        "change",
        'input[name="cross-over-product-quantity"]',
        function () {
          let parent = $(this).parents(".cross-sale-products__row");
          SingleProduct.updateCrossSaleRow(parent);
        }
      );
    }
  },

  updateCrossSaleRow: function (rowElem) {
    // Update front end
    let checkedRows = rowElem.find(".sale-product.checked");
    let price = 0;

    checkedRows.each(function () {
      let currentPrice = $(this).data("price");
      let quantity = $(this)
        .find('input[name="cross-over-product-quantity"]')
        .val();
      price = price + currentPrice * quantity;
    });
    let count = checkedRows.length;

    rowElem
      .find(".sale-product-info__price .price-text")
      .text(price.toFixed(2));
    rowElem.find(".sale-product-info__count .count").text(count);

    // Update hidden input value
    let data = [];
    checkedRows.each(function () {
      let id = $(this).data("id");
      let quantity = $(this)
        .find('input[name="cross-over-product-quantity"]')
        .val();
      let productData = {
        id: id,
        quantity: quantity,
      };
      data.push(productData);
    });
    rowElem.find('input[name="data"]').attr("value", JSON.stringify(data));
  },

  loadComments: function () {
    let button = $(".woocommerce-reviews__wrapper .read-more");

    if (button.length > 0) {
      let commentContainer = button.parent().siblings("ol#comments");
      let comments = commentContainer.find("li");
      let currentVisible = 4;
      let commentCount = comments.length;
      comments.slice(currentVisible, commentCount).addClass("hide");

      button.click(function () {
        currentVisible += 4;
        comments.slice(0, currentVisible).removeClass("hide");

        if (currentVisible >= commentCount) {
          $(this).remove();
        }
      });
    }

    $(".woocommerce-reviews__wrapper").removeClass("delay-load");
  },

  technicalDataCollapsing: function () {
    let container = $(".technical-data-container.collapsable");

    if (container.length > 0) {
      container.find(".technical-data-container__title").click(function () {
        $(this).parent().toggleClass("collapsed");
      });
    }
  },

  productNav: function () {
    let nav = $(".product-navigation");

    if (nav.length > 0) {
      let headerHeight = $("header.header").height();
      let offset = headerHeight + 100;

      nav.on("click", "li", function () {
        let scrollTo = $(this).data("item");
        $("html,body").animate(
          {
            scrollTop: $("#" + scrollTo).offset().top - offset,
          },
          "slow"
        );
      });
    }
  },

  reviewPopup: function () {
    let button = $(".add-review");
    let popUp = $("#review_form_pop-up");
    let close = popUp.find(".cg-pop-up__close");

    button.click(function () {
      popUp.removeClass("hidden");
    });

    close.click(function () {
      popUp.addClass("hidden");
    });

    $(document).mouseup(function (e) {
      let popUpContainer = popUp.find(".cg-pop-up__container");
      if (
        !popUpContainer.is(e.target) &&
        popUpContainer.has(e.target).length === 0
      ) {
        popUp.addClass("hidden");
      }
    });
  },

  productAccordions: function () {
    $(".accordion-item__top").on("click", function () {
      if ($(this).parent().hasClass("active")) {
        $(this).next().slideUp(300);
        $(this).parent().toggleClass("active");
      } else {
        $(this).next().slideDown(300);
        $(this).parent().toggleClass("active");
      }
    })

  },

  deliveryProgressIndicator: function () {
    const progressBar = $('.delivery-progress__bar')[0];
    const value = $('.delivery-progress__bar').data("progress");
    const percentage = (value / 100) * 100;

    if (progressBar) {
      progressBar.style.width = percentage + '%';
    }
  },

  form: function () {
    $("#receive-offer").on("submit", function (e) {
      e.preventDefault();

      const receiveOfferForm = $(this);

      $(".error", this).removeClass("error");
      if (helpers.validate(receiveOfferForm)) {
        receiveOfferForm.addClass("loading");

        setTimeout(function () {
          SingleProduct.submitForm(receiveOfferForm);
        }, 500);
      } else {
        receiveOfferForm.removeClass("loading");
      }
    });
  },

  submitForm: function (form) {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_site_key, {
          action: "contact",
        })
        .then(function (token) {
          SingleProduct.sendFormData(token);
        });
    });
  },

  sendFormData(token) {
    const receiveOfferForm = $("#receive-offer");
    receiveOfferForm.find("button").addClass("loading");
    receiveOfferForm.find(".form__status").addClass("hidden");

    const form_data = {
      email: receiveOfferForm.find('.field[name="email"]').val(),
      telephone: receiveOfferForm.find('.field[name="telephone"]').val(),
      message: receiveOfferForm.find('.field[name="message"]').val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_cform",
        form_data: form_data,
        token: token,
        post_id: receiveOfferForm.find("#post_id").val(),
        nonce: receiveOfferForm.find("#receive-offer-nonce").val(),
        honey: receiveOfferForm.find("#contact-honey").val(),
      },
    })
      .done(function (response) {
        if (response.success) {
          receiveOfferForm.find(".errors-wrap").remove();
          receiveOfferForm
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          receiveOfferForm[0].reset();
          receiveOfferForm.find("input, textarea").blur();
        } else {
          receiveOfferForm
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      })
      .always(function () {
        receiveOfferForm.removeClass("loading");
        receiveOfferForm.find("button").removeClass("loading");
      });
  },

  receiveOrderPopup: function () {
    let button = $(".availability-box__button");
    let popUp = $("#receive-offer-popup");
    let close = popUp.find(".cg-pop-up__close");

    button.click(function () {
      popUp.removeClass("hidden");
    });

    close.click(function () {
      popUp.addClass("hidden");
    });

    $(document).mouseup(function (e) {
      let popUpContainer = popUp.find(".cg-pop-up__container");
      if (
        !popUpContainer.is(e.target) &&
        popUpContainer.has(e.target).length === 0
      ) {
        popUp.addClass("hidden");
      }
    });
  },

  crossSaleSlider() {
    const wrapEl = $(".cross-sale-slider");
    if (!wrapEl) {
      return
    } else {
      let swiper = new Swiper(wrapEl.find(".cross-sale-slider__slider")[0],
        {
          slidesPerView: 1.6,
          loop: true,
          spaceBetween: 24,
          navigation: {
            prevEl: wrapEl.find(".cross-sale-slider__nav-prev")[0],
            nextEl: wrapEl.find(".cross-sale-slider__nav-next")[0],
          },
          breakpoints: {
            500: {
              slidesPerView: 2.5
            },
            600: {
              slidesPerView: 3,
            },

          }
        })
    }
  }
};



export default SingleProduct;
